module.exports = __webpack_public_path__ + "img/img-default.5da66ec0.png";